import dateFormat from '@/tools/dateFormat'

export default {
  data() {
    return {
      dateValue: '',
      pickerOptions2: { // 时间配置
        shortcuts: [{
            text: '最近一周',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近一个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近三个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
            }
        }]
      },
    }
  },
  methods: {
    dateChange(e) { // 时间格式化
      console.log(e)
      if(!e){
        if(this.type=='different'){
          this.searchQuery.startDate = ''
          this.searchQuery.endDate = ''
        }
        this.searchQuery.dateRange = ''
      }else{
        if(this.type=='different'){
          this.searchQuery.startDate = e[0]
          this.searchQuery.endDate = e[1]
        }
        e ? this.searchQuery.dateRange = e.join(',').replace(/-/g,'/').replace(',', '-') : this.searchQuery.dateRange = ''
      }

    },
  },
  created() {
    if(!this.noNeedForDate) {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      if(!this.noNeedInitDate) {
        this.dateValue = [start, end]
        this.searchQuery.dateRange = dateFormat(start, 'YYYY-MM-DD').replace(/-/g, '/') + '-' + dateFormat(end, 'YYYY-MM-DD').replace(/-/g, '/')

      }
    }
  }
}
